import { quillEditor } from "vue-quill-editor";
import 'quill/dist/quill.js';
import { Message } from "element-ui";
import {verify,removeRichTextLabel} from '../../assets/js/tools.js';
var oFile = null;
export default{
    name:'CommunicationPost',
    data(){
		var checkTitleName = (rule, value, callback) => {
			if (!value||verify('space',value)) {
			  return callback(new Error('标题不能为空'));
			}else{
				return callback();
			}
			
		};
		var checkOrgCode = (rule, value, callback) => {
			if (!value||verify('space',value)) {
			  return callback(new Error('机构名称不能为空'));
			}else{
				return callback();
			}
			
		};
        return{
			fileAccept: ['image/png','image/jpg','image/jpeg'], // 文件类型
            form:{
				titleName:'',
				sfType:'',
				deviceTypeCode:'',
				province:'',
				city:'',
				area:'',
				orgCode:'',
				isCopy:'',
			},
			content: '',
			contentState:false,
			editorOption: {
				modules: {
					toolbar: {
						container: [
							["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
							[{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
							[{ script: "sub" }, { script: "super" }], // 上标/下标
							[{ indent: "-1" }, { indent: "+1" }], // 缩进
							[{ size: ["small", false, "large", "huge"] }], // 字体大小
							[{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
							[{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
							[{ font: [] }], // 字体种类
							[{ align: [] }], // 对齐方式
							["clean"], // 清除文本格式
							["link", "image", "video"] // 链接、图片、视频
						], //工具菜单栏配置
						handlers: {
							image: function(value) {
								if (value) {
									oFile.click();
								} else {
									this.quill.format("image", false);
								}
							},
						}
					},	
				},
				placeholder: '请输入发稿内容', //提示
			},
			provinces:[],
			cities:[],
			areas:[],
			deviceList:[],
			sfList:[],
			orgList:[],
			rules:{
				titleName: [
					{ required: true, message: '请输入文章标题', trigger: 'change' },
					{ validator: checkTitleName, trigger: 'blur' },
					{ min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
				],
				sfType: [
					{ required: true, message: '请选择示范类型', trigger: 'change' },
				],
				deviceTypeCode: [
					{ required: true, message: '请选择设备类型', trigger: 'change' },
				],
				area: [
					{ required: true, message: '请选择完整地域', trigger: 'change' },
				],
				orgCode: [
					{ required: true, message: '请输入机构名称', trigger: 'change' },
					{ validator: checkOrgCode, trigger: 'blur' },
					{ min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
				],
				isCopy: [
					{ required: true, message: '请选择文章类型', trigger: 'change' },
				],
			}
			
        }
    },
    mounted () {
		oFile = this.$refs.uploadEditorFile;
		this.getProvinces();
		this.getDeviceList();
		this.getOrgList();
	},
    components:{
        quillEditor,
    },
    methods:{
        // 富文本上传图片
		uploadEditorFile () {
			var files = oFile.files;
			if (!files.length || this.fileAccept.indexOf(files[0].type) == -1) {
				oFile.value = '';
				return false;
			}
			var formData = new FormData();
			formData.append('upfile', files[0]);

			this.postFile(this.api.richTextFile, formData).then(res => {
				if (res.result == 200 && res.data.urls.length) {

					let quill = this.$refs.myQuillEditor.quill;
					// 获取光标所在位置
					let length = quill.getSelection().index;
					// 插入图片  res.url为服务器返回的图片地址
					quill.insertEmbed(length, "image", res.data.urls[0]);
					// 调整光标到最后
					quill.setSelection(length + 1);

					oFile.value = '';
				}
			})
        },
        onEditorChange (editor) {
			this.content = editor.html;
		},

		clear () {
			this.content = '';
        },
        submit(formName){
			this.$refs[formName].validate((valid) => {
				if (valid) {
					console.log("内容："+removeRichTextLabel(this.content));
					if(!this.content||verify('space',removeRichTextLabel(this.content))){
						this.contentState=true;
						return;
					}else{
						this.contentState=false;
					}
					var body={
						titleName:this.form.titleName,
						content:this.content,
						sfType:this.form.sfType,
						area:this.form.area,
						deviceTypeCode:this.form.deviceTypeCode,
						isCopy:this.form.isCopy,
						orgCode:this.form.orgCode,
						province:this.form.province,
						citie:this.form.city,
						area:this.form.area,
						isSubmit:1,
					};
					this.post(this.api.addArticle,body).then(res=>{
						if(res.result==200){
							this.$message({
								message: '添加成功',
								type: 'success'
							  });
							  this.routerToUrl('/communication');
						}
					}).catch(err=>{
						this.$message.error(err.msg);
					});
				}else{
					return;
				}
			});
            
		},
		getProvinces(){
			this.get(this.api.getProvinces).then(res=>{
				if(res.result==200){
					this.provinces=res.data;
				}
			}).catch();
		},
		getCities(){
			var body={
				code:this.form.province
			};
			this.get(this.api.getCities,body).then(res=>{
				if(res.result==200){
					this.cities=res.data;
				}
			}).catch();
		},
		getAreas(){
			var body={
				code:this.form.city
			};
			this.get(this.api.getAreas,body).then(res=>{
				if(res.result==200){
					this.areas=res.data;
				}
			}).catch();
		},
		getDeviceList(){
			this.get(this.api.getDeviceTypeList).then(res=>{
				if(res.result==200){
					this.deviceList=res.data;
				}
			}).catch();
		},
		getTypeCodes(){
			this.get(this.api.getTypeCodes).then(res=>{
				if(res.result==200){
					this.sfList=res.data;
				}
			}).catch();
		},
		getOrgList(){
			this.get(this.api.getOrgList).then(res=>{
				if(res.result==200){
					this.orgList=res.data;
				}
			}).catch();
		},
		emptyArticle(){
			this.$refs['form'].resetFields();
			this.content='';
			this.contentState=false;
			this.form.province='';
			this.form.city='';
		}	
    }
}